import ComparePlanDialogContainer from "./comparePlanDialog.container";

export default ComparePlanDialogContainer;
